import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import cx from 'classnames';
import { withStyles, createStyles } from '@material-ui/core/styles';
import DefaultObjectFormatter from './ObjectFormatter';
import Grid from '@material-ui/core/Grid';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import RootRef from '@material-ui/core/RootRef';
import { fade, darken } from '@material-ui/core/styles/colorManipulator';
import Icon from '../../../../core/Icon';
import responsive from './responsive';

var styles = function styles(theme) {
  var _theme$getStyle = theme.getStyle('Data.Grid'),
      selectionColor = _theme$getStyle.selectionColor,
      hoverColorBackground = _theme$getStyle.hoverColorBackground,
      contextMenuOpenedColor = _theme$getStyle.contextMenuOpenedColor;

  selectionColor = theme.getColor(selectionColor);
  hoverColorBackground = theme.getColor(hoverColorBackground);
  var selectionTextColor = theme.palette.getContrastText(selectionColor);
  var contextMenuOpenedTextColor = theme.palette.getContrastText(contextMenuOpenedColor);
  return createStyles({
    row: {
      height: 39,
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.complex
      }),
      '&$selectedRow': {
        backgroundColor: selectionColor,
        color: selectionTextColor,
        '&$hoveredRow:hover': {
          backgroundColor: fade(selectionColor, 0.85)
        },
        '& a': {
          color: selectionTextColor
        },
        '& $alignRight': {
          backgroundColor: darken(selectionColor, 0.1)
        },
        '&:hover $alignRight': {
          backgroundColor: selectionColor
        },
        '&:hover': {
          backgroundColor: hoverColorBackground
        }
      },
      '&:focus': {
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 1px 0px, rgba(0, 0, 0, 0.07) 0px 1px 1px 0px, rgba(0, 0, 0, 0.06) 0px 1px 1px 0px, rgba(0, 0, 0, 0.07) 0px -1px 1px 0px',
        '& td:first-of-type': {
          borderLeft: "2px solid ".concat(selectionColor)
        }
      },
      '&:hover': {
        '&:hover': {
          backgroundColor: hoverColorBackground
        }
      }
    },
    deletedRow: {
      opacity: 0.2
    },
    updatingRow: {
      opacity: 0.5
    },
    selectedRow: {},
    contextMenuOpenedRow: {
      backgroundColor: contextMenuOpenedColor + ' !important',
      color: contextMenuOpenedTextColor + ' !important'
    },
    hoveredRow: {},
    tableCell: {
      width: 100
    },
    tableCellBody: {
      color: 'inherit'
    },
    tableCellContent: {
      whiteSpace: 'nowrap',
      overflowX: 'hidden',
      textOverflow: 'ellipsis',
      '& p': {
        overflowX: 'hidden',
        textOverflow: 'ellipsis'
      }
    },
    alignRight: {
      backgroundColor: '#eee'
    },
    ctxMenuIcon: {
      fontSize: 18,
      display: 'block',
      cursor: 'pointer'
    }
  });
};
/** @extends {React.Component<import('./types').DataGridViewDetailItemProps & import('@material-ui/core').WithStyles<typeof styles>> } */


var GridViewDetailItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridViewDetailItem, _React$Component);

  function GridViewDetailItem() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, GridViewDetailItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GridViewDetailItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.rootRef = React.createRef();

    _this.onClick = function (e) {
      if (_this.props.onClick) _this.props.onClick(e, _this.props.item);
    };

    _this.onDoubleClick = function (e) {
      if (_this.props.onDoubleClick) _this.props.onDoubleClick(e, _this.props.item);
    };

    _this.onContextMenu = function (e, info) {
      if (_this.props.onContextMenu) {
        e.stopPropagation();

        _this.props.onContextMenu(e, _this.props.item, info);
      }
    };

    _this.onContextMenuButton = function (e) {
      return _this.onContextMenu(e, {
        origin: 'button'
      });
    };

    _this.isSelected = function (p) {
      var props = p ? p : _this.props;
      var isSelected = props.item ? props.item[props.config.selectedKeyProp || '_selected'] : false;
      if (!isSelected && props.selected === true) isSelected = true;
      return isSelected;
    };

    return _this;
  }

  _createClass(GridViewDetailItem, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.isSelected() && !this.isSelected(prevProps)) this.rootRef.current.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _cx,
          _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          config = _this$props.config,
          item = _this$props.item,
          showContextMenuIcon = _this$props.showContextMenuIcon,
          contextMenuOpened = _this$props.contextMenuOpened;
      var isSelected = this.isSelected();
      var rowProps = {
        className: cx(classes.row, (_cx = {}, _defineProperty(_cx, classes.deletedRow, item && item.__deleting), _defineProperty(_cx, classes.updatingRow, item && item.__updating), _cx)),
        hover: config.hoverable,
        selected: isSelected,
        onClick: this.onClick,
        onDoubleClick: this.onDoubleClick,
        onContextMenu: this.onContextMenu,
        classes: {
          selected: classes.selectedRow + (contextMenuOpened ? ' ' + classes.contextMenuOpenedRow : ''),
          hover: classes.hoveredRow
        },
        style: {
          cursor: this.props.onClick ? 'pointer' : ''
        }
      };
      return React.createElement(RootRef, {
        rootRef: this.rootRef
      }, React.createElement(TableRow, Object.assign({}, rowProps, {
        tabIndex: isSelected ? 0 : -1
      }), config.columns.map(function (col, idx) {
        var colWidth = responsive.getColumnWidth(col, _this2.props.width);
        if (colWidth === 0) return null; //collapse column

        var CrtCellFormatter = col.formatter || DefaultObjectFormatter;
        var cellProps = {
          classes: {
            alignRight: classes.alignRight,
            body: classes.tableCellBody
          },
          align: col.align ? col.align : col.numeric ? 'right' : 'inherit',
          className: classes.tableCell,
          scope: 'row',
          style: _objectSpread({
            width: colWidth
          }, col.style)
        };
        if (!item) return React.createElement(TableCell, Object.assign({
          key: col.id
        }, cellProps));
        var showContext = showContextMenuIcon;
        if (typeof col.showContextMenuIcon !== 'undefined') showContext = col.showContextMenuIcon;
        return React.createElement(TableCell, Object.assign({
          key: col.id
        }, cellProps), React.createElement(Grid, {
          container: true,
          direction: "row",
          alignItems: "center",
          justify: "space-between"
        }, React.createElement(Grid, {
          item: true,
          xs: true,
          className: classes.tableCellContent
        }, React.createElement(CrtCellFormatter, {
          data: item,
          config: config,
          column: col
        })), showContext && idx === 0 && React.createElement(Grid, {
          item: true
        }, React.createElement(Icon, {
          onClick: _this2.onContextMenuButton,
          className: classes.ctxMenuIcon,
          mini: true,
          type: "more",
          buttonProps: {
            tabIndex: isSelected ? 0 : -1
          }
        }))));
      })));
    }
  }]);

  return GridViewDetailItem;
}(React.Component);

GridViewDetailItem.defaultProps = {
  showContextMenuIcon: false,
  selected: false
};
export default withStyles(styles, {
  name: 'ECGridViewDetailItem'
})(GridViewDetailItem);